(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    (function() {
  function activateTab(tabs, panels, tab) {
    tabs.forEach(function(t) {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
      t.tabIndex = -1;
    });
    panels.forEach(function(p) {
      p.classList.remove('is-active');
      p.setAttribute('hidden', '');
    });
    tab.classList.add('is-active');
    tab.setAttribute('aria-selected', 'true');
    tab.tabIndex = 0;
    var panel = document.getElementById(tab.getAttribute('aria-controls'));
    if (panel) {
      panel.classList.add('is-active');
      panel.removeAttribute('hidden');
    }
  }

  document.querySelectorAll('.nsb-product-info-tabs').forEach(function(wrapper) {
    if (wrapper.dataset.nsbTabsReady === 'true') return;
    wrapper.dataset.nsbTabsReady = 'true';

    var tabs = Array.prototype.slice.call(wrapper.querySelectorAll('.nsb-tabs__tab'));
    var panels = Array.prototype.slice.call(wrapper.querySelectorAll('.nsb-tabs__panel'));
    if (!tabs.length) return;

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activateTab(tabs, panels, tab);
      });
      tab.addEventListener('keydown', function(event) {
        var index = tabs.indexOf(tab);
        var next = null;
        if (event.key === 'ArrowRight') {
          next = tabs[(index + 1) % tabs.length];
        } else if (event.key === 'ArrowLeft') {
          next = tabs[(index - 1 + tabs.length) % tabs.length];
        } else if (event.key === 'Home') {
          next = tabs[0];
        } else if (event.key === 'End') {
          next = tabs[tabs.length - 1];
        }
        if (!next) return;
        event.preventDefault();
        activateTab(tabs, panels, next);
        next.focus();
      });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
